export const EDITING_SR_SUBSCRIPTION_OPTIONS_MODAL_NAME =
  'EDITING_SR_SUBSCRIPTION_OPTIONS_MODAL_NAME';
